<div class="container mt-3" *ngIf="showCity(day)" [id]="day.city_name?.toLowerCase()">
  <div class="row">
    <div class="col-xs-12 col-md-4">
      <img class="img-fluid city-photo" [src]="urlCitiesImages + day.city_photo" alt="City"
          [fallbackSrc]="noImageUrl"
          [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
    </div>
    <div class="col-xs-12 col-md-8">
      <h5>
        <span class="text-capitalize">{{ (day.city_title?.trim() || day.city_name)?.toLowerCase() }}</span>
      </h5>
      <div class="itinerary-content" *ngIf="!day?.isIndipendentStay">
        <span class="itinerary-icons"><em class="fa fa-map-marker-alt"></em></span>
        <h6>
          <span class="text-capitalize">{{day.country_name?.toLowerCase()}}</span>
          -
          <a class="small" href="https://www.google.it/maps/search/{{ day.city_name }}"
            target="_blank" rel="noopener">
            {{ "ITINERARY.VIEW-ON-MAP" | translate }}
          </a>
        </h6>
      </div>
      <div class="itinerary-date d-none" *ngIf="!hideDate">
        {{ day.date | localizedDate: "dd MMMM, yyyy"}}
        <ng-container *ngIf="endDate">
          &ndash; {{ endDate | localizedDate: "dd MMMM, yyyy"}}
        </ng-container>
      </div>
    </div>
    <section class="col-12 right" *ngIf="day.city_description != ''">
      <details class="details details-city" open="true">
        <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
          attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
        </summary>
        <div class="row">
          <div class="col-12">
            <span [innerHTML]="day.city_description | safeHtml"></span>
          </div>
        </div>
      </details>
    </section>
  </div>
  <div class="col-12 mt-2 mb-2" *ngIf="showLineAfter(day)">
    <hr class="line-grey">
  </div>
</div>